<template>
  <div class="content--error">
    <MyHeader />

    <div class="error-body">
      <div class="error-content">
        <h1>Oops…</h1>
        <p>We can’t find the page that you’re looking for.</p>
        <p class="error-code">Error code: 404</p>
        <router-link :to="{name: 'Login'}"  class="button-icon button--submit">Go home <i class="icon-arrow"></i></router-link>
      </div>
      <div class="error-image">
        <img src="../../assets/images/errors/Error-404.svg">
      </div>
    </div>
    <MyFooter />
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import MyFooter from '../../components/general/Footer'
export default {
  name: "NotFound",
  components: { MyHeader, MyFooter },
}
</script>

<style scoped>

</style>
